/**
 * EP签证信息 - 表单默认值工厂 & 回显数据归一化
 * 弹窗初始化(AddOrUpdate)、回显平铺展示(index.vue) 共用，
 * 保证表单字段结构完整，避免模板访问 undefined 报错
 */

// ==================== 表单默认值工厂函数 ====================
export const createDataForm = () => ({
  fullName: null,
  nationality: null,
  identificationType: null,
  identificationNo: null,
  email: null,
  phone: "",
  residentialAddress: null,
  birthDate: null,
  isHoldShareOfPrcInland: 0,
  holdShareOfPrcEntity: null,
  applicantPersonalInfoUrls: [],
});

// ==================== 回显数据归一化 ====================
/**
 * 回显数据归一化：补全缺失字段
 * row 来自后端/父组件 value，字段可能缺失，直接渲染会访问 undefined
 */
export const normalizeEpVisaForm = row => ({
  ...createDataForm(),
  ...row,
  applicantPersonalInfoUrls: Array.isArray(row.applicantPersonalInfoUrls) ? row.applicantPersonalInfoUrls : [],
});
